import { schemeCategory10, schemeAccent, schemeDark2, schemePaired, schemePastel1, schemePastel2, schemeSet1, schemeSet2, schemeSet3, schemeTableau10, interpolateBrBG, schemeBrBG, interpolatePRGn, schemePRGn, interpolatePiYG, schemePiYG, interpolatePuOr, schemePuOr, interpolateRdBu, schemeRdBu, interpolateRdGy, schemeRdGy, interpolateRdYlBu, schemeRdYlBu, interpolateRdYlGn, schemeRdYlGn, interpolateSpectral, schemeSpectral, interpolateBlues, schemeBlues, interpolateGreens, schemeGreens, interpolateGreys, schemeGreys, interpolateOranges, schemeOranges, interpolatePurples, schemePurples, interpolateReds, schemeReds, interpolateTurbo, interpolateViridis, interpolateInferno, interpolateMagma, interpolatePlasma, interpolateCividis, interpolateWarm, interpolateCool, interpolateCubehelixDefault, interpolateBuGn, schemeBuGn, interpolateBuPu, schemeBuPu, interpolateGnBu, schemeGnBu, interpolateOrRd, schemeOrRd, interpolatePuBuGn, schemePuBuGn, interpolatePuBu, schemePuBu, interpolatePuRd, schemePuRd, interpolateRdPu, schemeRdPu, interpolateYlGnBu, schemeYlGnBu, interpolateYlGn, schemeYlGn, interpolateYlOrBr, schemeYlOrBr, interpolateYlOrRd, schemeYlOrRd, interpolateRainbow, interpolateSinebow } from 'd3-scale-chromatic';
const d3CategoricalSchemes = [{
  type: 'categorical',
  id: 'd3.category10',
  colors: schemeCategory10,
  label: "D3: Category10",
  description: 'Classic Ten categorical colors'
}, {
  type: 'categorical',
  id: 'd3.accent',
  colors: schemeAccent,
  label: "D3: Accent"
}, {
  type: 'categorical',
  id: 'd3.dark2',
  colors: schemeDark2,
  label: "D3: Dark2"
}, {
  type: 'categorical',
  id: 'd3.paired',
  colors: schemePaired,
  label: "D3: Paired"
}, {
  type: 'categorical',
  id: 'd3.pastel1',
  colors: schemePastel1,
  label: "D3: Pastel1"
}, {
  type: 'categorical',
  id: 'd3.pastel2',
  colors: schemePastel2,
  label: "D3: Pastel2"
}, {
  type: 'categorical',
  id: 'd3.set1',
  colors: schemeSet1,
  label: "D3: Set1"
}, {
  type: 'categorical',
  id: 'd3.set2',
  colors: schemeSet2,
  label: "D3: Set2"
}, {
  type: 'categorical',
  id: 'd3.set3',
  colors: schemeSet3,
  label: "D3: Set3"
}, {
  type: 'categorical',
  id: 'd3.tableau10',
  colors: schemeTableau10,
  label: "D3: Tableau10",
  description: 'Ten categorical colors authored by Tableau as part of Tableau 10'
}];
const d3DivergingSchemes = [{
  type: 'diverging',
  id: 'd3.RdBu',
  interpolator: interpolateRdBu,
  colors: schemeRdBu,
  label: 'D3: Red/Blue'
}, {
  type: 'diverging',
  id: 'd3.BrBG',
  interpolator: interpolateBrBG,
  colors: schemeBrBG,
  label: 'D3: Brown/BlueGreen'
}, {
  type: 'diverging',
  id: 'd3.PRGn',
  interpolator: interpolatePRGn,
  colors: schemePRGn,
  label: 'D3: PurpleRed/Green'
}, {
  type: 'diverging',
  id: 'd3.PiYG',
  interpolator: interpolatePiYG,
  colors: schemePiYG,
  label: 'D3: Pink/YellowGreen'
}, {
  type: 'diverging',
  id: 'd3.PuOr',
  interpolator: interpolatePuOr,
  colors: schemePuOr,
  label: 'D3: Purple/Orange'
}, {
  type: 'diverging',
  id: 'd3.RdGy',
  interpolator: interpolateRdGy,
  colors: schemeRdGy,
  label: 'D3: Red/Grey'
}, {
  type: 'diverging',
  id: 'd3.RdYlBu',
  interpolator: interpolateRdYlBu,
  colors: schemeRdYlBu,
  label: 'D3: Red/Yellow/Blue'
}, {
  type: 'diverging',
  id: 'd3.RdYlGn',
  interpolator: interpolateRdYlGn,
  colors: schemeRdYlGn,
  label: 'D3: Red/Yellow/Green'
}, {
  type: 'diverging',
  id: 'd3.spectral',
  interpolator: interpolateSpectral,
  colors: schemeSpectral,
  label: 'D3: Spectral'
}];
const d3SingleHueSchemes = [{
  type: 'sequential',
  id: 'd3.blues',
  interpolator: interpolateBlues,
  colors: schemeBlues,
  label: 'D3: Blues'
}, {
  type: 'sequential',
  id: 'd3.greens',
  interpolator: interpolateGreens,
  colors: schemeGreens,
  label: 'D3: Greens'
}, {
  type: 'sequential',
  id: 'd3.greys',
  interpolator: interpolateGreys,
  colors: schemeGreys,
  label: 'D3: Greys'
}, {
  type: 'sequential',
  id: 'd3.oranges',
  interpolator: interpolateOranges,
  colors: schemeOranges,
  label: 'D3: Oranges'
}, {
  type: 'sequential',
  id: 'd3.purples',
  interpolator: interpolatePurples,
  colors: schemePurples,
  label: 'D3: Purples'
}, {
  type: 'sequential',
  id: 'd3.reds',
  interpolator: interpolateReds,
  colors: schemeReds,
  label: 'D3: Reds'
}];
const d3MultiHueSchemes = [{
  type: 'sequential',
  id: 'd3.turbo',
  interpolator: interpolateTurbo,
  label: 'D3: Turbo'
}, {
  type: 'sequential',
  id: 'd3.viridis',
  interpolator: interpolateViridis,
  label: 'D3: Viridis'
}, {
  type: 'sequential',
  id: 'd3.inferno',
  interpolator: interpolateInferno,
  label: 'D3: Inferno'
}, {
  type: 'sequential',
  id: 'd3.magma',
  interpolator: interpolateMagma,
  label: 'D3: Magma'
}, {
  type: 'sequential',
  id: 'd3.plasma',
  interpolator: interpolatePlasma,
  label: 'D3: Plasma'
}, {
  type: 'sequential',
  id: 'd3.cividis',
  interpolator: interpolateCividis,
  label: 'D3: Cividis'
}, {
  type: 'sequential',
  id: 'd3.warm',
  interpolator: interpolateWarm,
  label: 'D3: Warm'
}, {
  type: 'sequential',
  id: 'd3.cool',
  interpolator: interpolateCool,
  label: 'D3: Cool'
}, {
  type: 'sequential',
  id: 'd3.cubehelixDefault',
  interpolator: interpolateCubehelixDefault,
  label: 'D3: Cube Helix'
}, {
  type: 'sequential',
  id: 'd3.BuGn',
  interpolator: interpolateBuGn,
  colors: schemeBuGn,
  label: 'D3: Blue/Green'
}, {
  type: 'sequential',
  id: 'd3.BuPu',
  interpolator: interpolateBuPu,
  colors: schemeBuPu,
  label: 'D3: Blue/Purple'
}, {
  type: 'sequential',
  id: 'd3.GnBu',
  interpolator: interpolateGnBu,
  colors: schemeGnBu,
  label: 'D3: Green/Blue'
}, {
  type: 'sequential',
  id: 'd3.OrRd',
  interpolator: interpolateOrRd,
  colors: schemeOrRd,
  label: 'D3: Orange/Red'
}, {
  type: 'sequential',
  id: 'd3.PuBuGn',
  interpolator: interpolatePuBuGn,
  colors: schemePuBuGn,
  label: 'D3: Purple/Blue/Green'
}, {
  type: 'sequential',
  id: 'd3.PuBu',
  interpolator: interpolatePuBu,
  colors: schemePuBu,
  label: 'D3: Purple/Blue'
}, {
  type: 'sequential',
  id: 'd3.PuRd',
  interpolator: interpolatePuRd,
  colors: schemePuRd,
  label: 'D3: Purple/Red'
}, {
  type: 'sequential',
  id: 'd3.RdPu',
  interpolator: interpolateRdPu,
  colors: schemeRdPu,
  label: 'D3: Red/Purple'
}, {
  type: 'sequential',
  id: 'd3.YlGnBu',
  interpolator: interpolateYlGnBu,
  colors: schemeYlGnBu,
  label: 'D3: Yellow/Green/Blue'
}, {
  type: 'sequential',
  id: 'd3.YlGn',
  interpolator: interpolateYlGn,
  colors: schemeYlGn,
  label: 'D3: Yellow/Green'
}, {
  type: 'sequential',
  id: 'd3.YlOrBr',
  interpolator: interpolateYlOrBr,
  colors: schemeYlOrBr,
  label: 'D3: Yellow/Orange/Brown'
}, {
  type: 'sequential',
  id: 'd3.YlOrRd',
  interpolator: interpolateYlOrRd,
  colors: schemeYlOrRd,
  label: 'D3: Yellow/Orange/Red'
}];
const d3CyclicalSchemes = [{
  type: 'sequential',
  id: 'd3.rainbow',
  interpolator: interpolateRainbow,
  label: 'D3: Rainbow'
}, {
  type: 'sequential',
  id: 'd3.sinebow',
  interpolator: interpolateSinebow,
  label: 'D3: Sinebow'
}];
const d3SequentialSchemes = d3SingleHueSchemes.concat(d3MultiHueSchemes).concat(d3CyclicalSchemes);
const d3Schemes = d3CategoricalSchemes.concat(d3DivergingSchemes).concat(d3SequentialSchemes);
export { d3Schemes, d3CategoricalSchemes, d3DivergingSchemes, d3SequentialSchemes, d3SingleHueSchemes, d3MultiHueSchemes, d3CyclicalSchemes };